<a *ngIf="routerLink" [routerLink]="[routerLink]">
    <app-icon [symbol]="symbol"></app-icon>
    <span>{{ label }}</span>
</a>
<a *ngIf="href" [href]="href" [target]="target">
    <app-icon [symbol]="symbol"></app-icon>
    <span>{{ label }}</span>
</a>
<a *ngIf="!href && !routerLink">
    <app-icon [symbol]="symbol"></app-icon>
    <span>{{ label }}</span>
</a>
